import type { IAssignmentRepository } from '@/core/domain/school/assignment/IAssignmentRepository'
import type { ValidModuleForAssignment } from '@/core/domain/school/assignment/ValidModuleForAssignment'

/**
 * Use case pour récupérer la liste des modules valides pour la matrice d'assignment
 */
export class FetchValidModulesForAssignmentUseCase {
  private assignmentRepository: IAssignmentRepository

  constructor(assignmentRepository: IAssignmentRepository) {
    this.assignmentRepository = assignmentRepository
  }

  async execute(schoolId: number, periodId: number): Promise<ValidModuleForAssignment[]> {
    return await this.assignmentRepository.fetchValidModulesForAssignment(schoolId, periodId)
  }
}
